import { render, staticRenderFns } from "./AnnualReports.vue?vue&type=template&id=13d0bcdc"
import script from "./AnnualReports.vue?vue&type=script&lang=js"
export * from "./AnnualReports.vue?vue&type=script&lang=js"
import style0 from "./AnnualReports.vue?vue&type=style&index=0&id=13d0bcdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports